import React from "react";

export const isPC = window.screen.width > 600;
export const isMobile = !isPC;

const PlatformWrap = ({
    mobile,
    pc,
    className
}: {
    mobile?: React.ReactNode;
    pc?: React.ReactNode;
    className?: string;
}) => {
    return <div className={className}>{isPC ? pc : mobile}</div>;
};

export default PlatformWrap;
